import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux'

import base from './base/reducer';
import vote from './vote/reducer';


const store = configureStore({
    reducer: {
        base,
        vote
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        thunk: true,  // thunk插件 可以直接处理异步  
    }),
    devTools: process.env.NODE_ENV === 'development',
})

export default store;

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch();


// thunk插件  需要配置的   thunk必须为true
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;